import GenericListSelection, { IGenericListSelectionProps } from 'components/GenericListSelection';
import { getTranslatedSystemRoles } from "lib/TranslationUtils";
import { SystemRoles } from "models/ApiEnums";
import { GenericListItemDto, PagedResult } from "models/ApiModels";
import * as React from 'react';

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

class UserRoleSelection extends React.Component<IGenericListSelectionProps> {

    private getRoles = (searchText: string, offset: number, take: number): Promise<PagedResult<GenericListItemDto>> => {
        return new Promise((resolve) => {
            var roles = getTranslatedSystemRoles();
            var data = roles
                .filter(p => p.key != SystemRoles.None && p.key != SystemRoles.All && (searchText == null || p.value.indexOf(searchText) > -1))
                .map((v) => { return { id: v.key.toString(), name: v.value, thumbnailUrl: null } as GenericListItemDto; });

            resolve({ items: data, total: roles.length } as PagedResult<GenericListItemDto>);
        });
    };

    render() {
        return (
            <GenericListSelection
                title="Papéis"
                showThumbnail={false}
                multi={this.props.multi}
                onGetData={this.getRoles}
                onSelect={this.props.onSelect}
            />
        );
    }
}

export default UserRoleSelection;